import type { FC } from 'react';

import { VariantPickerCTA } from '@/productDiscovery/ProductPage/common/modules/VariantPicker/VariantPickerCTA';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

export const ModelsListManager: FC = () => {
  const { isSellable, totalModels, variants } = useDetail();
  if (totalModels < 2 || !!variants || !isSellable) return null;

  return <VariantPickerCTA />;
};
